import { render } from "./RemediationSystem.vue?vue&type=template&id=fafb0eae&scoped=true"
import script from "./RemediationSystem.vue?vue&type=script&lang=ts"
export * from "./RemediationSystem.vue?vue&type=script&lang=ts"

import "./RemediationSystem.vue?vue&type=style&index=0&id=fafb0eae&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-fafb0eae"

export default script